"use client";

import { useNoteLabel, useNoteLabels } from "@/hooks/use-notation";
import { Note } from "@/lib/music/note";

interface PressedPillProps {
  midis: ReadonlySet<number>;
}

export function PressedPill({ midis }: PressedPillProps) {
  const toNoteLabel = useNoteLabel();
  const noteLabels = useNoteLabels();

  if (midis.size === 0) {
    return null;
  }

  const sorted = Array.from(midis).sort((a, b) => a - b);

  if (sorted.length === 1) {
    const name = toNoteLabel(
      Note.fromMidi(sorted[0]).toName({
        preferSharps: true,
        withOctave: true,
      }),
    );

    return (
      <div className="pointer-events-none flex h-8 items-center rounded-full border border-border-subtle bg-bg-elevated/95 px-3 font-mono text-[11px] text-text-secondary shadow-md backdrop-blur-sm">
        {name}
      </div>
    );
  }

  const names = noteLabels(
    sorted.map((m) =>
      Note.fromMidi(m).toName({ preferSharps: true, withOctave: false }),
    ),
  );

  return (
    <div className="pointer-events-none flex h-8 items-center rounded-full border border-accent/40 bg-accent/15 px-3 font-mono text-[11px] text-accent-bright shadow-md backdrop-blur-sm">
      {names.join(" · ")}
    </div>
  );
}
